<template>
  <div class="about">
    <h1>This is a Contact page</h1>
    <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maiores blanditiis rerum saepe quibusdam necessitatibus assumenda minus eaque autem reiciendis vel atque esse ratione eius recusandae beatae, corporis temporibus inventore! Eveniet.</p>
  </div>
</template>

<style scoped>
h1{
  margin-top: 50px;
  margin-bottom: 30px;
}
p{
  display: flex;
  justify-content: center;
  margin: auto;
}
</style>